import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as Utils from '../../util/colors';
import styles from './proposal-option-bar.less';

interface ProposalOptionBarProps {
    text?: string;
    backgroundColor?: string;
    className?: string;
    showAsTag?: boolean;
}

const ProposalOptionBar = ({
    text,
    backgroundColor,
    showAsTag,
    className,
}: ProposalOptionBarProps) => {
    const barColor = backgroundColor || '#DFE0E1';
    return (
        <div
            className={classNames(styles.container, { [styles.showAsTag]: showAsTag }, className)}
            style={{ color: Utils.generateFontColor(barColor), backgroundColor: barColor }}
        >
            {text || ''}
        </div>
    );
};

ProposalOptionBar.propTypes = {
    text: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
};

export { ProposalOptionBar };
